import { mergeAttributes, Node } from '@tiptap/core'
import config from 'config'

export const StepperItem = Node.create({
  name: 'stepperItem',

  //group: 'block',

  content: 'text*',

  //defining: true,

  isolating: true,

  addAttributes() {
    return {
      status: {
        default: 'pending',
        parseHTML: element => element.getAttribute('data-status') || 'pending',
        renderHTML: attributes => ({
          'data-status': attributes.status,
          'data-type': this.name
        })
      },
      first: {
        default: false,
        parseHTML: element => element.getAttribute('data-first') === 'true',
        renderHTML: attributes => attributes.first ? { 'data-first': 'true' } : {}
      },
      last: {
        default: false,
        parseHTML: element => element.getAttribute('data-last') === 'true',
        renderHTML: attributes => attributes.last ? { 'data-last': 'true' } : {}
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: `tr[data-type="${this.name}"]`,
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const status = HTMLAttributes['data-status'] || 'pending'

    const isFirst = HTMLAttributes['data-first']
  const isLast = HTMLAttributes['data-last']

  let className = `stepper-item-status stepper-item-status--${status}`
  if (isFirst) className += ' stepper-item-status--first'
  if (isLast) className += ' stepper-item-status--last'

    return [
      'tr',
      mergeAttributes(HTMLAttributes, { 'data-type': this.name }),
      [
        'td',
        {
          class: className,
          width: '28px',
          style: `width: 28px; height: 46px; text-align: center; padding: 0 !important; background-image: url("${config.api}/assets/dotted-line.png"); background-repeat: no-repeat; background-position: top center;`,
          background: `url("${config.api}/assets/dotted-line.png")`,
          bgcolor: '#FFFFFF'
        },
        ['img', {
          src: `${config.api}/assets/status/${status}.png`,
          alt: status,
          width: '16px',
        }]
      ],
      ['td', { width: 'auto' }, 0]]
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        if (!editor.isActive('stepperItem')) return false
        const pos = editor.state.selection.$from.end()

        return editor.chain().focus(pos).insertContentAt(pos, { type: 'stepperItem' }).updateStepperItemPositions().run()
      },
      Backspace: ({ editor }) => {
        if (!editor.isActive('stepperItem')) return false

        const { $from } = editor.state.selection
        const node = $from.node()

        // Verifica se o nó está vazio
        if (node.content.size === 0) {
          const pos = $from.before()

          // Verifica se não é o primeiro item
          if (pos <= 1) return false

          const prevPos = editor.state.doc.resolve(pos - 1)

          editor.chain()
            .deleteNode('stepperItem')
            .focus(prevPos.end())
            .updateStepperItemPositions()
            .run()

          return true
        }

        return false
      }
    }
  },
})

export default StepperItem
